import { ChangeDetectionStrategy, Component, EventEmitter, Input, InputSignal, OnInit, Output, ViewChild, WritableSignal, computed, input, model, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule, SelectChangeEvent, Select } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { Subscription } from 'rxjs';
import { MessageServiceEnum } from 'src/app/api';
import { ParticipantSearchResult, ParticipantService } from 'src/app/api/participant.service';
import { MissionControlHostService } from 'src/app/mission-control-host.service';
import { ErrorService } from 'src/app/services/error.service';
import { InputRestrictionDirective } from 'src/app/ui/directives/input-restriction.directive';
import { Options } from 'src/app/ui/dropdowns/dropdown-option.service';
import { SaveButtonComponent } from 'src/app/ui/save-button/save-button.component';
import { NewuserResolverParams, NewuserWithArchive, ParticipantSearchQuery } from 'src/generated/graphql';

type AudienceOption = "all" | "test" | "carissa" | "preview-group" | "custom"

@Component({
    selector: 'app-send-text-message',
    imports: [TextareaModule, FormsModule, SelectModule, InputRestrictionDirective, SaveButtonComponent, ProgressSpinnerModule],
    templateUrl: './send-text-message.component.html',
    styleUrl: './send-text-message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SendTextMessageComponent implements OnInit {



  private _customAudience: number[] = []
  @Input() set customAudience(value: number[]) {
    this._customAudience = value
    if (value.length > 0) {

      this.audienceOptions.set([
        ...this.baseAudienceOptions,
        { label: "Custom", value: "custom" }
      ])

      this.audienceParams["custom"].newuserIds = value
      this.selectedAudience.set("custom")

    }
    else {
      this.audienceOptions.set([...this.baseAudienceOptions])
      this.audienceParams["custom"].newuserIds = [-1]
    }
    this.loadAudience()
  }

  get customAudience(): number[] {
    return this._customAudience
  }

  private readonly baseAudienceOptions: Options<AudienceOption>[] = [
    { label: "All", value: "all" },
    { label: "Carissa", value: "carissa" },
    { label: "Preview Group", value: "preview-group" },
    // { label: "Test", value: "test" }
  ]

  audienceOptions: WritableSignal<Options<AudienceOption>[]> = signal([
    ...this.baseAudienceOptions
  ])

  selectedAudience = model<AudienceOption>("carissa")

  audience: WritableSignal<ParticipantSearchQuery['newusers']> = signal([])
  textMessage = model<string>("")

  subscriptions: Subscription[] = []

  loadingAudience: WritableSignal<boolean> = signal(false)

  @ViewChild(SaveButtonComponent) saveButton!: SaveButtonComponent

  @Output() messageSent: EventEmitter<void> = new EventEmitter<void>()

  audienceParams: { [prop: string]: NewuserResolverParams } = {
    "all": {},
    "carissa": { newuserIds: [4035] },
    "preview-group": { newuserIds: [4035, 7799, 13311, 55023, 121912] },
    "custom": { newuserIds: [-1] }
  }

  constructor(
    private participantService: ParticipantService,
    private messageService: MessageService,
    private errorService: ErrorService
  ) {

  }

  ngOnInit(): void {
    this.loadAudience()

  }

  selectedAudienceChange(event: SelectChangeEvent) {
    this.loadAudience()

  }


  loadAudience() {
    this.loadingAudience.set(true)
    let params: NewuserResolverParams = {
      smsActive: true
    }

    if (this.audienceParams[this.selectedAudience()]) {
      params = {
        ...params,
        ...this.audienceParams[this.selectedAudience()]
      }
    }


    this.participantService.participantSearch(params).subscribe({
      next: (result) => {

        if (result.error) {
          this.errorService.error("There was a problem loading the audience information.  Please reaload and try again", result.error, this.messageService)
        }
        else {
          this.audience.set(result.data.newusers)
        }

        this.loadingAudience.set(false)
      },
      error: (err) => {
        this.errorService.error("There was a problem loading the audience information.  Please reaload and try again", err, this.messageService)
        this.loadingAudience.set(false)
      }
    }

    )


  }


  sendMessage() {

    const audience = this.audience()
    
    if (audience) {

      this.participantService.sendTextMessage(
        audience.map(u => parseInt(u.id)), { message: this.textMessage(), messageService: MessageServiceEnum.Marketing }
      ).subscribe({
        next: (result) => {
          this.messageService.add({ detail: "Message Sent", severity: "success" })
          this.textMessage.set("")
          this.saveButton.saveComplete()

          this.messageSent.emit()
        },
        error: (err) => {
          this.errorService.error("There was a problem sending your message", err, this.messageService)
          this.saveButton.saveComplete()
        }
      })
    }
  }

}
